import React, { useState, useEffect, useContext } from "react";
import { Row, Col, Container, Tab, Nav, Form } from "react-bootstrap";
import CustomTooltip from "utils/CustomTooltip";
import Search from "./Search";
import Display from "./Display";
import Social from "./Social";
import Video from "./Video";
import BackButton from "../BackButton";
import NextButton from "../NextButton";
import SkipButton from "../SkipButton";
import getNextPage from "../getNextPage";
import updateParams from "utils/updateParams.js";
import { RouterContext } from "../Onboarding";

export default function PPCDashboardCustomization(props) {
  const route = useContext(RouterContext);

  const nextPage = getNextPage(props.onboarding_progress);

  useEffect(() => {
    window.localStorage.setItem("routerHistory", JSON.stringify([...route.get]));
  }, [route.get]);
  props.pageLocator();
  const [tabLocation, setTabLocation] = useState("");
  const [validated, setValidatation] = useState(false);

  useEffect(() => {
    let searchParams = new URL(location.href).searchParams;
    let page = searchParams.get("page");
    if (!page || page == "") {
      page = "search";
    }
    setTabLocation(page);
  }, []);

  const selectTab = (key) => {
    setTabLocation(key);
    updateParams("page", key);
  };

  const [showBoxes, setShowBoxes] = useState(false);
 
  return (
    <Container fluid className="px-5 collapse-padding-mobile">
      <Row className="px-4 mb-3 pb-3 justify-content-center collapse-padding-mobile">
        <Col md={10}>
          <Row className=" mb-1  justify-content-center">
            <Col md={9}>
              <div>
                <p className="pb-3 f28 visby-bold primary text-center">PPC Dashboard Customization - Services</p>
              </div>
              <div>
                <p className=" f16 nunito-regular  primary ">Would you like to customize your PPC dashboards now or use the default settings?</p>
              </div>
            </Col>
          </Row>

          <Row className="mb-3 pb-3 justify-content-center">
            <Col md={9}>
              <div className="pb-1 pt-2">
                <CustomTooltip
                  faClass="far fa-question-circle pb-1 f16 text-info pt-1 pr-2"
                  message={
                    "Check the box to enable/disable, and click and drag the left handle to reorder your dashboard. Click 'Display configuration' to configure which metrics will show in each section."
                  }
                  inline={true}
                />{" "}
                <span className=" f16 text-info ">What does this mean?</span>
              </div>
              <div className="d-flex flex-column ">
                <Form.Check
                  className="f16"
                  name="ob-dash-custom"
                  custom
                  label="I will use the default configuration"
                  type="radio"
                  id="ob-dash-custom-no"
                  onClick={() => {
                    setShowBoxes(false);
                    setValidatation(true);
                    props.setSearchDefault(true)
                    props.setDisplayDefault(true)
                    props.setSocialDefault(true)
                    props.setVideoDefault(true)
                  }}
                />
                <Form.Check
                  name="ob-dash-custom"
                  className="f16"
                  custom
                  label="I want to customize my dashboard layout now"
                  type="radio"
                  id="ob-dash-custom-yes"
                  onClick={() => {
                    setShowBoxes(true);
                    setValidatation(true);
                    props.setSearchDefault(false)
                    props.setDisplayDefault(false)
                    props.setSocialDefault(false)
                    props.setVideoDefault(false)
                  }}
                />
              </div>
            </Col>
          </Row>
          <Row className="mt-4 mb-2 justify-content-center">
            <Col md={11}>
              <p className="f14 primary">
                Check the boxes to enable/disable sections, and then click and drag dashboard boxes to reorder how they will appear in your performance
                dashboards:
              </p>
              <br></br>
              <p className="f14 primary">
                You will configure the "All" PPC dashboard on the next page and available options will be dependent on how the below services are set up.
              </p>
            </Col>
          </Row>
        </Col>
      </Row>
      <div className="mx-0 tab-shadow mask-wrapper">
        {showBoxes === false && <div className="mask"></div>}
        <Tab.Container id="account-config-tabs" defaultActiveKey="search" activeKey={tabLocation} onSelect={(k) => selectTab(k)}>
          <Nav variant="pills" className="pt-0  pb-0 nav-fill tabs-navigation-2 row no-gutters row-cols-sm-1 row-cols-lg-4 trim-padding">
            <Nav.Item className="col">
              <Nav.Link eventKey="search" className="tab-titles">
                Search
              </Nav.Link>
            </Nav.Item>
            <Nav.Item className="col">
              <Nav.Link eventKey="display" className="tab-titles">
                Display
              </Nav.Link>
            </Nav.Item>
            <Nav.Item className="col">
              <Nav.Link eventKey="social">Social</Nav.Link>
            </Nav.Item>
            <Nav.Item className="col">
              <Nav.Link eventKey="video" className="tab-titles">
                Video
              </Nav.Link>
            </Nav.Item>
          </Nav>
          <Tab.Content>
            <Tab.Pane className="" eventKey="search">
              {props.search_section.enabled ? (
                <Search {...props} />
              ) : (
                <div style={{ backgroundColor: "#F5F5F5" }}>
                  <Row className="p-4">
                    <Col>
                      <div className="py-4">
                        <p>Search is not currently enabled</p>
                      </div>
                    </Col>
                  </Row>
                </div>
              )}
            </Tab.Pane>
            <Tab.Pane eventKey="display">
              {props.display_section.enabled ? (
                <Display {...props} />
              ) : (
                <div style={{ backgroundColor: "#F5F5F5" }}>
                  <Row className="p-4">
                    <Col>
                      <div className="py-4">
                        <p>Display is not currently enabled</p>
                      </div>
                    </Col>
                  </Row>
                </div>
              )}
            </Tab.Pane>
            <Tab.Pane eventKey="social">
              {props.social_section.enabled ? (
                <Social {...props} />
              ) : (
                <div style={{ backgroundColor: "#F5F5F5" }}>
                  <Row className="p-4">
                    <Col>
                      <div className="py-4">
                        <p>Social is not currently enabled</p>
                      </div>
                    </Col>
                  </Row>
                </div>
              )}
            </Tab.Pane>
            <Tab.Pane eventKey="video">
              {props.video_section.enabled ? (
                <Video {...props} />
              ) : (
                <div style={{ backgroundColor: "#F5F5F5" }}>
                  <Row className="p-4">
                    <Col>
                      <div className="py-4">
                        <p>Video is not currently enabled</p>
                      </div>
                    </Col>
                  </Row>
                </div>
              )}
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </div>
      <Row className="mt-5 justify-content-center">
        <Col>
          <div className="navButtonRow">
            <BackButton />
            <SkipButton btnText={`Skip for now`} nextPage={nextPage.url} />
            <NextButton
              validated={validated}
              btnText={`Next`}
              nextPage={nextPage.url}
              invalidText={`We need more information on this page before you continue.`}
              submitForm={props.submitForm}
            />
          </div>
        </Col>
      </Row>
    </Container>
  );
}
